<div class="logo">
    <img src="images/aradalogo.png" alt="logo" class="logo__image">
</div>
